export const eventReports = {
	tabs: {
		resume: "Resume",
		promotion: "Promotions used",
		debtors: "Open accounts",
		devolution: "Card devolution per box",
		cashierClosings: "Cashier closings",
		userBonus: "Bonus",
		discounts: "Account discounts",
		minimumConsumption: "Early consumption",
		consumptionObligation: "Minimum consumption",
		refunded: "Refunded products",
		servicesRemoval: "Services removed",
		bonusByProduct: "Bonus per product",
		rechargeConsumption: "Recharges devolution",
		refundedRecharges: "Refunded recharges",
		individualLimitPost: "Change of individual post limit",
		rappiDiscounts: "Rappi Discounts",
		openedBillPayment: "Open account payments",
		openedBillReports: {
			stillOpenInPeriod: "Still open in period",
			stillOpenInPeriodTooltip:
				"Refers to the value of open accounts in the selected period",
			linksGenerated: "Generated links",
			paidInPeriod: "Open account payments resolved in period",
			tabs: {
				debtors: "Open accounts",
				payments: "Open account payments",
			},
		},
		openSales: "Open sales",
		afterClosingEvent: "Actions synced after event",
		forciblySynchronizedBalances: "Forcibly Synchronized Balances",
		tipReport: "Tip Report",
		transactionTransferReport: "Transaction transfers",
	},
	resumeReport: {
		title: "Resume",
		finished: {
			end: "Closed: {{end}}h",
			not: "The event has not closed",
		},
		reportIn: "Billing for event '{{eventName}}'",
		fileName: "billing-{{eventName}}",
	},
	debtorsReport: {
		title: "Open accounts",
		modal: {
			confirm: "Confirm",
			yes: "Yes",
			no: "No",
			paymentMethodError: "Select a payment method",
			pay: "Pay",
			placeScope: "place",
			eventScope: "event",
			paymentConfirm_part1: "This payment",
			paymentConfirm_part2: "will pay ALL customer debt",
			paymentConfirm_part3: "in {{scope}}, are you sure you want to do this?",
			paymentMethod: "Payment method",
			postEvent: "Mark as paid",
			bonus: "Pay with bonus",
			cash: "Cash",
			creditCard: "Credit card",
			debitCard: "Debit card",
			voucher: "Voucher",
			multiplePaymentConfirm_part1: "This payment ",
			multiplePaymentConfirm_part2: "will pay {{value}}",
			multiplePaymentConfirm_part3:
				"from customer in {{scope}}, are you sure you want to do this?",
			multiplePaymentError: "Attention! Add a payment method",
			discharge: "Discharge",
			column: {
				bonus: "Bonus",
				value: "Value",
			},
			openConsumption: "Open consumption",
			total: "Total",
			service: "Service ({{tip}}%)",
			paymentConsumption: "Paying in consumption",
			paymentService: "Paying in service",
			submitError:
				"It is only possible to overpay up to 25% of the total outstanding amount.",
			select: "Select",
			addPayment: "Add payment",
			reason: "Justification",
			reasonPlaceholder: "Add bonus justification",
			observation: "Observation",
			observationPlaceholder: "Add an observation",
			pixCharge: "PIX's charge",
			sendCharge: "Send Charge",
			openValues: "Open values",
			totalDebit: "Total debit",
			pixValue: "Pix value",
			email: "Email",
			emailPlaceholder: "Email's customer",
			fieldRequired: "Field Required",
			emailError: "Invalid email",
			phoneError: "Invalid phone",
			openService: "Open Service",
		},
		alertTitleOpenBill: "It is not possible to send bills in the event report",
		alertMessageOpenBill:
			"To send bills, go to the [Locations] menu > select the location > [Financial Reports] menu > 'Outstanding Accounts' tab and use the link in the 'Charge' column.",
	},
	cashierClosings: {
		card: {
			total: "TOTAL",
			closed: "Closed",
			open: "Open",
			received: "Billed",
			difference: "Difference",
			casher_one: "{{numberOfCashiers}} Cashier",
			cashier_other: "{{numberOfCashiers}} Cashiers",
			notClosed_one: "({{numberOfOpenCashiers}} not closed)",
			notClosed_other: "({{numberOfOpenCashiers}} not closed)",
			modality: "Modality",
			noFlag: "No Flag",
			cash: "Cash",
			cardDevolution: "Card devolutions",
			productDevolution: "Product Returns",
			bleeding: "Bleeding",
			changeFund: "Change fund",
			rechargeDevolutions: "Recharge devolutions",
			xlsx: {
				modality: "Modality",
				received: "Billed",
				closed: "Closed",
				difference: "Difference",
				closingResume: "Closing Summary",
				cashier: "Cashier",
				closingCashier: "Closing by Cashier",
				filenameEvent: "closing-by-cashier-{{eventDate}}",
				filename: "closing-by-cashier-in-place",
			},
		},
		header: {
			cashierHistory: "View cashier history",
			transactionalHistory: "View transactional history",
			addBleed: "Add bleed",
			addChange: "Add change fund",
			reopenCashier: "Are you sure you want to reopen the cashier?",
			reopenCashierButton: "Reopen cashier",
			closeCashier: "Are you sure you want to close the {{cashierName}} cashier?",
			closeCashierButton: "Close cashier",
			historyTitle: "Cashier history - {{cashierName}}",
			obs: "Observation",
			addObs: "Add observation",
		},
		modal: {
			cashiers: "Cashier",
			value: "Value",
			changeFund: "Change fund",
			history: "Historic",
			historyTitle: "History of {{name}}",
			cashierPosts: "Post-paid transactions",
			cashierRecharges: "Recharges",
			addFlag: "Add flag",
			saveValues: "Saving values",
			refundPayment: "Payment refund",
			column: {
				client: "Customer",
				clients: "Customer(s)",
				zigCode: "ZigTag",
				date: "Date",
				method: "Method",
				valueRecharged: "Recharged value",
				valueComsumed: "Consumed Value",
				total: "Total",
				payments: "Payments",
				serialNumber: "Serial number (SN)",
				author: "Employee",
				obs: "Observation",
			},
		},
		valueGreaterThanZero: "The value must be greater than 0",
		value: "Value",
		cashier: "Cashier",
		noCard: "No card",
		noCashierSelected: "No cashier selected",
		all: "All",
		total: "Total",
		info: {
			closingCashier: "Cashier closing",
			cashierReceipt: "Income by cashier",
			changeFund: "Change fund",
			changes: "Changes",
			cashier_one: "cashier",
			cashier_other: "cashier",
			notClosed: "not closed",
			billed: "Invoiced",
			bleeds: "Bleeds",
			devolutions: "Returned",
			closed: "Closed",
			negative: "Difference",
			searchCashier: "Search cashier by name",
			cashierNotClosed: "Cashier not closed",
			createBleed: "Create bleed",
			createChange: "Add change fund",
			bleeding: "Bleeding",
			cardDevolution: "Card devolution",
			rechargeDevolutions: "Recharge devolutions",
			addNewModality: "Add new modality",
			closeCashier: "Close cashier",
			cancel: "Cancel changes",
			save: "Save closing",
			modality: "Modality",
			totalClosed: "Total Closed",
			totalBilled: "Total Billed",
		},
		paymentMethod: {
			debit: "Debit",
			cash: "Money",
			credit: "Credit",
			zigDebit: "Zig Debit",
			zigCredit: "Credit Zig",
			postEvent: "Paid after event",
			voucher: "Voucher",
			dashboard: "Dashboard",
			anticipated: "Anticipated",
			subtotal: "Subtotal",
			devolution: "Devolutions",
			total: "Total",
			ame: "Ame",
			deliveryOnline: "Delivery Online",
			rappi: "Rappi",
			ifood: "Ifood",
			uber: "Uber",
			pix: "Pix",
			bonus: "Bonus",
			installment: "Installment",
			foodVoucher: "Food Voucher",
			online: "Online",
			mbway: "MBWay",
		},
		transactionsTitle: "History of {{name}}",
		postPaid: "Postpaid transactions",
		recharges: "Recharges",
		balanceTitleDay: "Income per cashier on day {{day}}",
		balanceTitle: "Income per cashier",
		filenameBalance: "income_per_cashier",
	},
	minimumConsumption: {
		title: "Early consumption",
	},
	refunded: {
		title: "Refunded/Cancelled Products",
		filename: "refunded-products",
		zigTable: "Zig Table",
		zigTag: "Zig Card",
		zigFicha: "Zig Ficha",
		columns: {
			date: "Date",
			name: "Product's name",
			category: "Category",
			type: "Type",
			canceled: "Cancelado",
			refunded: "Refunded",
			refundedBy: "Refunded By",
			soldBy: "Sold By",
			refundObs: "Observation",
			reason: "Reason",
			clients: "Customers",
			operationType: "Operation",
			count: "Quantity",
			value: "Value",
			totalRefunded: "Total ({{total}} refunded)",
			totalValue: "Total Value",
			totalCount: "Total amount",
			moreRefundedBuyer_other: "and {{buyers}} more people",
			moreRefundedBuyer_one: "and {{buyers}} more person",
		},
	},
	servicesRemoval: {
		title: "Removal of services by cashier",
		titlePrint: "Services Removed",
		goTo: "go to",
		clientInfo: "Customer Information",
		columns: {
			date: "Date",
			total: "Total Removed",
			name: "Customer",
			value: "Value",
			reason: "Reason",
			employee: "Employee",
		},
	},
	rechargeConsumption: {
		title: "Recharge devolution",
		filename: "recharge-devolution",
		detailDialog: "View recharge returned by the cashier",
		rechargesRefundedBy: "Recharges returned by {{author}}",
		columns: {
			author: "Cashier",
			ame: "Ame",
			anticipated: "Anticipated",
			cash: "Cash",
			credit: "Credit",
			dashboard: "Dashboard",
			debit: "Debit",
			deliveryOnline: "Online Delivery",
			ifood: "Ifood",
			pix: "PIX",
			rappi: "Rappi",
			uber: "Uber",
			voucher: "Voucher",
			total: "Total",
			client: "Client",
			method: "Method",
			value: "Value",
			integratedFoodVoucher: "Meal voucher",
			zigPosCreditInInstallments: "Installment credit",
		},
	},
	individualLimitPost: {
		title: "Customer information",
		titleTab: "Individual post limit change",
		searchPlaceholder: "Search by user, id or name",
		filename: "individual_pos_limit_change_report",
		columns: {
			username: "User",
			client: "Customer",
			employeeName: "Employee",
			date: "Time",
			limit: "Limit increase",
			newLimite: "New limit",
			emptyText: "No data to display.",
		},
	},
	rappiDiscounts: {
		title: "Rappi Discounts",
		rappiDiscounts: "DRappi Discounts",
		filename: "rappi_discount_report",
		columns: {
			products: "Products",
			date: "Date",
			value: "Discount vallue",
			employee: "Employee who applied the discount",
		},
	},
	openedBillPayment: {
		title: "Open account payments",
		filename: "report_of_payments_of_accounts_in_open_in_event",
		columns: {
			client: "Customer",
			document: "Document",
			openedEventDate: "Open account date",
			employeeName: "Paid for",
			method: "Method",
			tipValue: "Tip value",
			value: "Value",
		},
	},
	afterClosingEvent: {
		title: "Actions synced after event",
		description: "Report with actions or transactions after the event closes.",
		searchLabel: "Search by employee's name",
		searchPlaceHolder: "Enter the employee's name",
		filterTransactionLabel: "Filter by transaction type",
		filterOriginLabel: "Visualize",
		offlineActionLabel: "After closing",
		historyMachineLabel: "History machine",
		historyMachineAfterClosingLabel: "History after closing",
		optionAll: "All transactions",
		optionOfflineAction: "Transactions synchronized after event close",
		optionHistoryMachine: "Transactions machine's history",
		optionHistoryMachineAfterClosing: "Transactions machine's history after event close",
		columns: {
			transactionType: "Transaction type",
			employee: "Employee",
			customerName: "Users name",
			date: "Date/Hour of sync",
			value: "value",
			origin: "origin",
		},
	},
	forciblySynchronizedBalance: {
		title: "Forcibly Synchronized Balances",
		table: {
			columns: {
				date: "Date/Time",
				user: "Client",
				employee: "Employee",
				reason: "Justification",
				balance: "Synchronized Balance",
			},
		},
		successfulExportMsg: "Spreadsheet successfully exported!",
	},
};
